/**
 * Typed environment variable accessors.
 * All variables must be prefixed with VITE_ to be exposed to the client bundle.
 */

export const APP_NAME = import.meta.env.VITE_APP_NAME ?? "Veltro";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "";

export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? "").trim();
export const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? "").trim();

export const R2_PUBLIC_URL = (import.meta.env.VITE_R2_PUBLIC_URL ?? "").trim();

export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;
